"use client";

import { usePathname } from "next/navigation";
import DownloadIcon from "./components/DownloadIcon";
import AudioIcon from "./components/AudioIcon";
import { useAudio } from "./contexts/AudioContext";
import PauseIcon from "./components/PauseIcon";
export default function HeaderSubtitle() {
  const pathname = usePathname();
  const { togglePlayPause, isPlaying } = useAudio();
  return <div>
    {(pathname === "/" || pathname?.includes("/supplements/") || pathname === "/summary") && <>
      <h2 className="mt-[-3px] mb-[10px] not-italic text-[21px] md:text-[24px] leading-[1.4] font-normal bg-[var(--vivid-background)] w-fit relative pb-[10px]" style={{ zIndex: 1 }}>
        <div className="flex items-center font-bold md:hidden mb-2">
          April 3rd 2025
          <div className="w-[1px] h-[16px] bg-black mx-2" />
          <a target="_blank" href="/ai-2027.pdf" className="flex items-center no-underline">
            <DownloadIcon /> <span className="ml-2">PDF</span> </a>
          <div className="w-[1px] h-[16px] bg-black mx-2" />
          <span className="cursor-pointer flex items-center" onClick={togglePlayPause}>
            {isPlaying ? <PauseIcon /> : <AudioIcon />}
            <span className="ml-2">{isPlaying ? "Pause" : "Listen"}</span>
          </span>
        </div>
        <span className="tracking-[-1.2px]">Daniel&nbsp;Kokotajlo, Scott&nbsp;Alexander, Thomas&nbsp;Larsen, Eli&nbsp;Lifland, Romeo&nbsp;Dean</span>
      </h2>
    </>}
  </div>
}